import { memo } from "react";
import Typography from "@mui/material/Typography";

import {
  CRM_DISPLAY_EMPTY,
  formatLastAppointmentDisplay,
  formatPatientBirthDateDisplay,
  formatPatientPhoneDisplay,
  formatPatientTaxIdentifierDisplay,
} from "../helpers/formatCrmCommunicationsDisplay";
import type { CrmPatientSummary } from "../types";

export interface PatientSummaryTableCellContentProps {
  patient: CrmPatientSummary | undefined;
}

/** Contato: telefone formatado + e-mail em caption (paridade com dialogs/atalho). */
export const PatientContactTableCellContent = memo(
  ({ patient }: PatientSummaryTableCellContentProps) => {
    if (!patient) {
      return <>{CRM_DISPLAY_EMPTY}</>;
    }

    const email = patient.email?.trim();

    return (
      <>
        {formatPatientPhoneDisplay(patient.phone)}
        {email ? (
          <Typography variant="caption" display="block" color="text.secondary">
            {email}
          </Typography>
        ) : null}
      </>
    );
  },
);

PatientContactTableCellContent.displayName = "PatientContactTableCellContent";

export const PatientBirthDateTableCellContent = memo(
  ({ patient }: PatientSummaryTableCellContentProps) => {
    if (!patient) {
      return <>{CRM_DISPLAY_EMPTY}</>;
    }
    return <>{formatPatientBirthDateDisplay(patient.birthDate)}</>;
  },
);

PatientBirthDateTableCellContent.displayName = "PatientBirthDateTableCellContent";

export const PatientTaxIdentifierTableCellContent = memo(
  ({ patient }: PatientSummaryTableCellContentProps) => {
    if (!patient) {
      return <>{CRM_DISPLAY_EMPTY}</>;
    }
    return (
      <>{formatPatientTaxIdentifierDisplay(patient.taxIdentifierValue)}</>
    );
  },
);

PatientTaxIdentifierTableCellContent.displayName =
  "PatientTaxIdentifierTableCellContent";

export const PatientLastAppointmentTableCellContent = memo(
  ({ patient }: PatientSummaryTableCellContentProps) => {
    if (!patient) {
      return <>{CRM_DISPLAY_EMPTY}</>;
    }
    return <>{formatLastAppointmentDisplay(patient.lastAppointmentAt)}</>;
  },
);

PatientLastAppointmentTableCellContent.displayName =
  "PatientLastAppointmentTableCellContent";
